import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=b20bc8c0&scoped=true&"
import script from "./SelectLanguage.vue?vue&type=script&lang=js&"
export * from "./SelectLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguage.vue?vue&type=style&index=0&id=b20bc8c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20bc8c0",
  null
  
)

export default component.exports